import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { PAYMENT_PLANS_KEY } from '../constants/storage';
import { PaddleProducts, PricingParams } from '../types/pricing.types';
import { Organization } from '../types/services.types';

type PricingPlanStore = {
  organization?: Organization;
  paddleProducts?: PaddleProducts;
  params?: PricingParams;
  setOrganization: (organization: Organization) => void;
  setPaddleProducts: (products?: PaddleProducts) => void;
  setParams: (params: Partial<PricingPlanStore>) => void;
};

export const usePricingPlansStore = create<PricingPlanStore>()(
  persist(
    (set) => ({
      setParams(params) {
        set(params);
      },
      setOrganization(organization) {
        set({ organization });
      },
      setPaddleProducts(paddleProducts) {
        set({ paddleProducts });
      }
    }),
    {
      name: PAYMENT_PLANS_KEY, // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage) // (optional) by default, 'localStorage' is used
    }
  )
);
